export default __webpack_public_path__ + "static/media/location_icon.3cd835fe.png";